module.exports = __webpack_public_path__ + "static/media/logout_white.918ace54.svg";